import React from 'react'
import { MachineRankingExports } from '../../machinesranking/wizard/Exports'

export const FleetUtilizationExports = ({ disabled = false }: { disabled?: boolean }) =>
  <MachineRankingExports report='fleetutilization' disabled={disabled} />
